<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import Chart from 'chart.js'

const props = defineProps({
    chartData: { type: Array, default: () => [] },
    chartType: { type: String, default: 'vehicle' },
    frotaElec: { type: [String, Number], default: '' },
    label:     { type: String, default: '' },
})

const canvasRef  = ref(null)
const legendHtml = ref('')
let chart = null

function draw() {
    if (!canvasRef.value || !props.chartData.length) return
    const ctx = canvasRef.value.getContext('2d')
    ctx.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height)
    if (chart) chart.destroy()
    chart = new Chart(canvasRef.value, {
        type: 'doughnut',
        data: {
            labels:   props.chartData.map(d => d.nome),
            datasets: [{ data: props.chartData.map(d => d.quantidade), backgroundColor: props.chartData.map(d => d.cor) }],
        },
        options: {
            layout:              { padding: { right: window.innerWidth > 768 ? 100 : 0 } },
            cutoutPercentage:    80,
            maintainAspectRatio: false,
            legend:              { display: false },
            legendCallback(c) {
                return '<ul>' + c.data.datasets[0].data.map((qty, i) => {
                    const color  = c.data.datasets[0].backgroundColor[i]
                    const lbl    = c.data.labels[i] || ''
                    const suffix = ` (${qty})`
                    return `<li><span style="background-color:${color}"></span>${lbl}${suffix}</li>`
                }).join('') + '</ul>'
            },
            elements: { arc: { borderWidth: 0 } },
            scales: {
                xAxes: [{ gridLines: { display: false }, ticks: { display: false } }],
                yAxes: [{ gridLines: { display: false }, ticks: { display: false } }],
            },
        },
    })
    legendHtml.value = chart.generateLegend()
}

watch(() => props.chartData, draw, { deep: true })
onMounted(draw)
onBeforeUnmount(() => { if (chart) chart.destroy() })
</script>

<template>
    <div :class="`data__chart data__chart--${chartType}`">
        <div class="chart__container">
            <canvas ref="canvasRef"></canvas>
            <div class="frota-elec__container" :class="chartType === 'manufactor' ? 'frota-elec__container--manufactor' : ''">
                <p>{{ label }}</p>
                <h1>{{ frotaElec }}</h1>
            </div>
        </div>
        <div :class="`chart__legend chart__legend--${chartType}`" v-html="legendHtml"></div>
    </div>
</template>
